import { TheNightlySection } from '@news-mono/common'
import { StaticRoutes } from '@news-mono/web-common'
import { createLatestEditionPage } from './latestEdition'

export const ePaper: StaticRoutes<TheNightlySection> = {
    '/editions': (services) => {
        return createLatestEditionPage(services, 'default', 'The Nightly')
    },
}
